addEventListener('DOMContentLoaded', _ => {
    if (document.querySelectorAll('.fluid-margin-container-left').length > 0 ) {
        containerFluidLeftUpdate();
    }
    if (document.querySelectorAll('.fluid-margin-container-right').length > 0 ) {
        containerFluidRightUpdate();
    }
})

addEventListener('resize', _ => {
    if (document.querySelectorAll('.fluid-margin-container-left').length > 0 ) {
        containerFluidLeftUpdate();
    }
    if (document.querySelectorAll('.fluid-margin-container-right').length > 0 ) {
        containerFluidRightUpdate();
    }
})

function containerFluidRightUpdate(){
    const simulatedContainer = window.getComputedStyle(document.querySelector('.container'));
    const simContainerRight = simulatedContainer.getPropertyValue('margin-right');
    const fluidRightArray = document.querySelectorAll('.fluid-margin-container-right');
    fluidRightArray.forEach(container => {
        container.style.marginRight = simContainerRight;
    });
}

function containerFluidLeftUpdate(){
    const simulatedContainer = window.getComputedStyle(document.querySelector('.container'));
    const simContainerLeft = simulatedContainer.getPropertyValue('margin-left');
    const fluidLeftArray = document.querySelectorAll('.fluid-margin-container-left');
    console.log(document.querySelector('.container').style.marginLeft)
    console.log(simContainerLeft)
    fluidLeftArray.forEach(container => {
        container.style.marginLeft = simContainerLeft;
    });
}